import React, { Fragment } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Api from '../../api/api';
import DinamicTable from '../common/dinamic-table';
import OverlayLoading from '../common/overlay-loading';

export default class Users extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            modal: false,
            id: null,
            form: {
                role: 'user',
                username: '',
                validTwoFA: 'FALSE',
                resetPassword: 'TRUE',
            }
        }
    }

    componentDidMount = () => {
        this.updateTable();
    }

    updateTable = async () => {
        await this.setState({ loading: true });
        let req = await Api.get('users');
        if (!req.error) {
            let rows = req.data;
            console.log(rows)
            let cols = [
                'Username',
                '2FA',
                'Role',
                '<button>Edit'
            ]
            rows = rows.map(row => {
                return [
                    row.username,
                    row.validTwoFA ? 'TRUE' : 'FALSE',
                    row.role,
                    row,
                ]
            })
            this.table.updateTable(cols, rows);
        }
        await this.setState({ loading: false });
    }

    deleteRow = async (id) => {
        let response = window.confirm("ATTENTION!!! This action cannot be undone.");
        if (response) {
            let req = await Api.del(`users/${id}`);
            if (!req.error) {
                this.updateTable();
                this.setState({ modal: false })
            }
        }
    }

    openRow = (row) => {
        this.setState({
            modal: true,
            id: row.id,
            form: {
                role: row.role,
                username: row.username,
                validTwoFA: row.validTwoFA ? 'TRUE' : 'FALSE',
                resetPassword: row.resetPassword ? 'TRUE' : 'FALSE',
            }
        })
    }

    newRow = () => {
        this.setState({
            modal: true,
            id: null,
            form: {
                role: 'user',
                username: '',
                validTwoFA: 'FALSE',
                resetPassword: 'TRUE',
            }
        })
    }

    saveRow = async () => {
        await this.setState({ loading: true });
        let form = this.state.form;
        if (this.state.id) {
            await Api.patch(`users/${this.state.id}`, {
                role: form.role,
                username: form.username,
                validTwoFA: form.validTwoFA === 'TRUE',
                resetPassword: form.resetPassword === 'TRUE',
            })
        } else {
            await Api.post(`users`, {
                role: form.role,
                username: form.username
            })
        }
        this.updateTable();
        this.setState({ modal: false, loading: false })
    }

    handleChange = (event) => {
        let form = this.state.form
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
        form[event.target.name] = value
        this.setState({ form })
    }

    toggleModal = () => {
        this.setState({ modal: !this.state.modal })
    }

    render() {
        return (
            <Fragment>
                <OverlayLoading show={this.state.loading} />
                <div className="container-fluid pt-5">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col">
                                            <h5>Users</h5>
                                        </div>
                                        <div className="col">
                                            <div className="pull-right right-header">
                                                <button className="btn btn-primary" onClick={() => this.newRow()}>Create User</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <DinamicTable
                                    size="5"
                                    ref={ref => this.table = ref}
                                    openRow={this.openRow}
                                    deleteRow={this.deleteRow}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} size="lg" centered>
                    <ModalHeader toggle={this.toggleModal}>{this.state.id ? 'Edit' : 'New'} User</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-md">
                                <div className="form-group">
                                    <label>Username</label>
                                    <input className="form-control"
                                        type="text"
                                        name="username"
                                        value={this.state.form.username}
                                        onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="col-md">
                                <div className="form-group">
                                    <label>Role</label>
                                    <select className="form-control digits"
                                        name="role"
                                        value={this.state.form.role}
                                        onChange={this.handleChange}>
                                        <option>{"super"}</option>
                                        <option>{"user"}</option>
                                        <option>{"onlyRead"}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {this.state.id && <div className="row">
                            <div className="col-md">
                                <div className="form-group">
                                    <label>2FA</label>
                                    <select className="form-control digits"
                                        name="validTwoFA"
                                        value={this.state.form.validTwoFA}
                                        onChange={this.handleChange}>
                                        <option>{"TRUE"}</option>
                                        <option>{"FALSE"}</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md">
                                <div className="form-group">
                                    <label>Reset Password</label>
                                    <select className="form-control digits"
                                        name="resetPassword"
                                        value={this.state.form.resetPassword}
                                        onChange={this.handleChange}>
                                        <option>{"TRUE"}</option>
                                        <option>{"FALSE"}</option>
                                    </select>
                                </div>
                            </div>
                        </div>}
                    </ModalBody>
                    <ModalFooter>
                    {this.state.id && <button className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={() => this.deleteRow(this.state.id)}>Delete</button>}
                        <button className="btn btn-primary" onClick={this.saveRow}>Save</button>
                        <button className="btn btn-secondary" onClick={this.toggleModal}>Cancel</button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}